import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoldIcon, InfoCircleBoldIcon, SuccessCircleBoldIcon, WarningBoldIcon } from '@pattern-library/icon';
const propTypes = {
  /**
   * The message(s) to display in the alert
   */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * The row id of the row that the alert is associated with
   */
  rowId: PropTypes.number,
  /**
   * The type of alert to display
   */
  type: PropTypes.oneOf(['error', 'warning', 'default', 'success'])
};
const inlineAlertIcons = {
  error: /*#__PURE__*/React.createElement(ErrorBoldIcon, {
    size: "sm",
    color: "error"
  }),
  warning: /*#__PURE__*/React.createElement(WarningBoldIcon, {
    size: "sm",
    color: "warning"
  }),
  default: /*#__PURE__*/React.createElement(InfoCircleBoldIcon, {
    size: "sm",
    color: "black"
  }),
  success: /*#__PURE__*/React.createElement(SuccessCircleBoldIcon, {
    size: "sm",
    color: "success"
  })
};
function InlineAlert(_ref) {
  let {
    message,
    rowId,
    type = 'default'
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `asc-table-component-inline-alert-message asc-table-component-inline-alert-message--${type}`
  }, inlineAlertIcons[type], Array.isArray(message) ? /*#__PURE__*/React.createElement("div", {
    className: "asc-table-component-inline-alert-message-list"
  }, message.map((msg, i) => {
    return /*#__PURE__*/React.createElement("p", {
      key: `row-${rowId}warn-msg-${i}`
    }, msg);
  })) : /*#__PURE__*/React.createElement("span", {
    className: "asc-table-component-inline-alert-single-message"
  }, message));
}
InlineAlert.propTypes = propTypes;
export default InlineAlert;